module.exports = __webpack_public_path__ + "img/fb_icon.ab7b031b.svg";